import React, { useState, useEffect } from "react";
import { useForm, ValidationError } from '@formspree/react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

function ContactForm() {
  const [state, handleSubmit] = useForm("xzzroarv");
  const { t } = useTranslation('contact');
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const defaultMessage = queryParams.get('message') || '';
  const defaultSubject = queryParams.get('subject') || '';

  const [message, setMessage] = useState(defaultMessage);
  const [subject, setSubject] = useState(defaultSubject);
  const [customSubject, setCustomSubject] = useState('');
  const [otherSubject, setOtherSubject] = useState('');

  if (state.succeeded) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '60px 40px',
        backgroundColor: '#f8f9fa',
        borderRadius: '16px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}>
        <div style={{ 
          width: '60px', 
          height: '60px', 
          backgroundColor: 'rgb(73, 69, 56)', 
          borderRadius: '50%', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          margin: '0 auto 30px'
        }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.5" style={{ width: '32px', height: '32px' }}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h3 style={{ 
          fontSize: '2rem', 
          fontWeight: '600', 
          color: '#1a1a1a', 
          marginBottom: '20px',
          fontFamily: 'Montserrat, sans-serif'
        }}>{t('form.successTitle')}</h3>
        <p style={{ 
          fontSize: '1.1rem', 
          color: '#6b7280', 
          lineHeight: '1.6' 
        }}>{t('form.successMessage')}</p>
      </div>
    );
  }

  return (
    <div style={{ height: '100%' }}>
      <div className="mb-4">
        <h2 style={{
          fontSize: '2.2rem',
          fontWeight: '400',
          color: '#1a1a1a',
          marginBottom: '15px',
          fontFamily: 'Montserrat, sans-serif',
          letterSpacing: '-0.02em'
        }}>
          {t('form.title')}
        </h2>
        <p style={{
          fontSize: '1rem',
          color: '#6b7280',
          lineHeight: '1.6'
        }}>
          {t('form.subtitle')}
        </p>
      </div>

      <form onSubmit={handleSubmit} style={{ marginTop: '30px' }}>
            <div className="row g-4">
              <div className="col-md-6">
                <div style={{ marginBottom: '30px' }}>
                  <label 
                    htmlFor="name"
                    style={{
                      display: 'block',
                      marginBottom: '12px',
                      fontSize: '0.95rem',
                      fontWeight: '500',
                      color: '#374151'
                    }}
                  >
                    {t('form.fields.name')} <span style={{ color: 'rgb(73, 69, 56)' }}>*</span>
                  </label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    placeholder={t('form.placeholders.name')}
                    required
                    style={{
                      width: '100%',
                      padding: '14px 18px',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      color: '#1f2937',
                      transition: 'all 0.3s ease',
                      backgroundColor: '#ffffff'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'rgb(73, 69, 56)'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  />
                  <ValidationError prefix="Name" field="name" errors={state.errors} />
                </div>
              </div>

              <div className="col-md-6">
                <div style={{ marginBottom: '30px' }}>
                  <label 
                    htmlFor="email"
                    style={{
                      display: 'block',
                      marginBottom: '12px',
                      fontSize: '0.95rem',
                      fontWeight: '500',
                      color: '#374151'
                    }}
                  >
                    {t('form.fields.email')} <span style={{ color: 'rgb(73, 69, 56)' }}>*</span>
                  </label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    placeholder={t('form.placeholders.email')}
                    required
                    style={{
                      width: '100%',
                      padding: '14px 18px',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      color: '#1f2937',
                      transition: 'all 0.3s ease',
                      backgroundColor: '#ffffff'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'rgb(73, 69, 56)'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  />
                  <ValidationError prefix="Email" field="email" errors={state.errors} />
                </div>
              </div>

              <div className="col-md-6">
                <div style={{ marginBottom: '30px' }}>
                  <label 
                    htmlFor="phone"
                    style={{
                      display: 'block',
                      marginBottom: '12px',
                      fontSize: '0.95rem',
                      fontWeight: '500',
                      color: '#374151'
                    }}
                  >
                    {t('form.fields.phone')} <span style={{ color: 'rgb(73, 69, 56)' }}>*</span>
                  </label>
                  <input
                    id="phone"
                    type="tel"
                    name="phone"
                    placeholder={t('form.placeholders.phone')}
                    required
                    style={{
                      width: '100%',
                      padding: '14px 18px',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      color: '#1f2937',
                      transition: 'all 0.3s ease',
                      backgroundColor: '#ffffff'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'rgb(73, 69, 56)'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  />
                  <ValidationError prefix="Phone" field="phone" errors={state.errors} />
                </div>
              </div>

              <div className="col-md-6">
                <div style={{ marginBottom: '30px' }}>
                  <label 
                    htmlFor="subject"
                    style={{
                      display: 'block',
                      marginBottom: '12px',
                      fontSize: '0.95rem',
                      fontWeight: '500',
                      color: '#374151'
                    }}
                  >
                    {t('form.fields.subject')} <span style={{ color: 'rgb(73, 69, 56)' }}>*</span>
                  </label>
                  <select
                    id="subject"
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                      if (e.target.value !== 'custom' && e.target.value !== 'other') {
                        setCustomSubject('');
                        setOtherSubject('');
                      }
                    }}
                    required={subject !== 'other' && subject !== 'custom'}
                    style={{
                      width: '100%',
                      padding: '14px 18px',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      color: '#1f2937',
                      transition: 'all 0.3s ease',
                      backgroundColor: '#ffffff',
                      cursor: 'pointer',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 18px center',
                      backgroundSize: '12px',
                      paddingRight: '45px'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'rgb(73, 69, 56)'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  >
                    <option value="">{t('form.placeholders.subject')}</option>
                    <option value="custom">{t('form.subjects.custom')}</option>
                    <option value="belleMare">{t('form.subjects.belleMare')}</option>
                    <option value="paradisepark">{t('form.subjects.paradisepark')}</option>
                    <option value="botanicheska302">{t('form.subjects.botanicheska302')}</option>
                    <option value="fifthelement">{t('form.subjects.fifthelement')}</option>
                    <option value="garden">{t('form.subjects.garden')}</option>
                    <option value="m1">{t('form.subjects.m1')}</option>
                    <option value="m2">{t('form.subjects.m2')}</option>
                    <option value="prestigepark">{t('form.subjects.prestigepark')}</option>
                    <option value="signature">{t('form.subjects.signature')}</option>
                    <option value="theframe">{t('form.subjects.theframe')}</option>
                    <option value="grandparkliving">{t('form.subjects.grandparkliving')}</option>
                    <option value="joinTeam">{t('form.subjects.joinTeam')}</option>
                    <option value="other">{t('form.subjects.other')}</option>
                  </select>
                  {subject === 'custom' && (
                    <input
                      type="text"
                      name="subject"
                      value={customSubject}
                      onChange={(e) => setCustomSubject(e.target.value)}
                      placeholder={t('form.placeholders.subject')}
                      required
                      style={{
                        width: '100%',
                        padding: '14px 18px',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        color: '#1f2937',
                        transition: 'all 0.3s ease',
                        backgroundColor: '#ffffff',
                        marginTop: '12px'
                      }}
                      onFocus={(e) => e.target.style.borderColor = 'rgb(73, 69, 56)'}
                      onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                    />
                  )}
                  {subject === 'other' && (
                    <div style={{ marginTop: '12px' }}>
                      <label 
                        htmlFor="otherSubject"
                        style={{
                          display: 'block',
                          marginBottom: '12px',
                          fontSize: '0.95rem',
                          fontWeight: '500',
                          color: '#374151'
                        }}
                      >
                        {t('form.fields.subject')} <span style={{ color: 'rgb(73, 69, 56)' }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="otherSubject"
                        name="subject"
                        value={otherSubject}
                        onChange={(e) => setOtherSubject(e.target.value)}
                        placeholder={t('form.placeholders.subject')}
                        required
                        style={{
                          width: '100%',
                          padding: '14px 18px',
                          border: '1px solid #e5e7eb',
                          borderRadius: '8px',
                          fontSize: '1rem',
                          color: '#1f2937',
                          transition: 'all 0.3s ease',
                          backgroundColor: '#ffffff'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'rgb(73, 69, 56)'}
                        onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                      />
                    </div>
                  )}
                  {subject !== 'custom' && subject !== 'other' && (
                    <input type="hidden" name="subject" value={subject} />
                  )}
                  <ValidationError prefix="Subject" field="subject" errors={state.errors} />
                </div>
              </div>

              <div className="col-12">
                <div style={{ marginBottom: '30px' }}>
                  <label 
                    htmlFor="message"
                    style={{
                      display: 'block',
                      marginBottom: '12px',
                      fontSize: '0.95rem',
                      fontWeight: '500',
                      color: '#374151'
                    }}
                  >
                    {t('form.fields.message')} <span style={{ color: 'rgb(73, 69, 56)' }}>*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    placeholder={t('form.placeholders.message')}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    style={{
                      width: '100%',
                      padding: '14px 18px',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      color: '#1f2937',
                      transition: 'all 0.3s ease',
                      backgroundColor: '#ffffff',
                      resize: 'vertical',
                      minHeight: '150px'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'rgb(73, 69, 56)'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  ></textarea>
                  <ValidationError prefix="Message" field="message" errors={state.errors} />
                </div>
              </div>
            </div>

            <div style={{ marginTop: '40px', textAlign: 'center' }}>
              <button 
                type="submit" 
                disabled={state.submitting}
                style={{
                  backgroundColor: 'rgb(73, 69, 56)',
                  color: '#ffffff',
                  border: 'none',
                  padding: '16px 48px',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: state.submitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: state.submitting ? 0.7 : 1
                }}
                onMouseEnter={(e) => {
                  if (!state.submitting) {
                    e.target.style.backgroundColor = '#a86f42';
                    e.target.style.transform = 'translateY(-2px)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgb(73, 69, 56)';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                {state.submitting ? t('form.sending') : t('form.submitButton')}
              </button>

              <p style={{
                fontSize: '0.9rem',
                color: '#6b7280',
                marginTop: '30px',
                lineHeight: '1.6'
              }}>
                {t('form.terms')}{' '}
                <a
                  href="/innerpages/terms"
                  style={{
                    color: 'rgb(73, 69, 56)',
                    textDecoration: 'none',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                >
                  {t('form.termsLink')}
                </a>
              </p>
            </div>
          </form>
    </div>
  );
}

export default ContactForm;
